import script from "./PhotoScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoScreen.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoScreen.vue?vue&type=style&index=0&id=5b6db8f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b6db8f3"]])

export default __exports__